import { NavLink } from 'react-router-dom'
import { Home, CheckSquare, Clock, CalendarDays, Bot } from 'lucide-react'
import useTaskStore from '../store/taskStore'
import { useFeature } from '../config/features'
import { useT } from '../i18n/useT'

export default function BottomNav() {
  const t = useT()
  const can = useFeature()
  const { openAgent, openPremiumModal } = useTaskStore()

  const NAV = [
    { to: '/',           icon: Home,          key: 'nav_dashboard' },
    { to: '/attivita',   icon: CheckSquare,   key: 'nav_tasks'     },
    { to: '/calendario', icon: CalendarDays,  key: 'nav_calendar'  },
    { to: '/scadenze',   icon: Clock,         key: 'nav_deadlines' },
  ]

  const handleAgentClick = (e) => {
    e.preventDefault()
    if (can('agent_chat')) {
      openAgent()
    } else {
      openPremiumModal('premium')
    }
  }

  return (
    <nav className="bottom-nav" id="tour-nav" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      {NAV.map(({ to, icon: Icon, key }) => (
        <NavLink
          key={to}
          to={to}
          end={to === '/'}
          className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
        >
          <Icon className="nav-icon" size={22} strokeWidth={2} />
          {t(key)}
        </NavLink>
      ))}
      <button id="tour-agent" className="nav-item nav-item--agent" onClick={handleAgentClick}>
        <span className="nav-icon-wrap">
          <Bot className="nav-icon" size={22} strokeWidth={2} />
          <span className="nav-icon-dot" aria-hidden="true" />
        </span>
        {t('nav_agent')}
      </button>
    </nav>
  )
}
